export const GET_LINK_MANAGEMENT_REQUEST = "GET_LINK_MANAGEMENT_REQUEST"
export const GET_LINK_MANAGEMENT_SUCCESS = "GET_LINK_MANAGEMENT_SUCCESS"

export const STATUS_LINK_CHANGE_REQUEST = "STATUS_LINK_CHANGE_REQUEST"
export const STATUS_LINK_CHANGE_SUCCESS = "STATUS_LINK_CHANGE_SUCCESS"

export const ADD_LINK_REQUEST = "ADD_LINK_REQUEST"
export const ADD_LINK_SUCCESS = "ADD_LINK_SUCCESS"